// @ts-nocheck
import React from 'react';
import {setupInterceptorsTo} from "../../Componentes/API/AxiosBuilder";
import {EXTENSION_MAIL_INSTITUCIONAL, RUTA_API_USUARIOS} from "../../Contantes/Constantes";
import axios from 'axios';
import Modal from '@mui/material/Modal';
import {useBody} from "../../Body/state/BodyContext";
import {FormularioAlta} from "../FormularioAlta";
import {ModalGeneral} from "../../Componentes/ModalGeneral";
import {useFormulario} from "../State/FormularioState/FormularioContext";

export default function ModalModificarAlta ({open,onClose,uid}) {
    const {setSuccess,setMessage} = useBody();
    const {resetearForm,setFechaNacimiento} = useFormulario();
    const [usuario, setUsuario] = React.useState({
        nombre: '',
        apellido: '',
        uid: '',
        frbaEmail: EXTENSION_MAIL_INSTITUCIONAL,
        fechaNacimiento: null,
        SexoId: 0,
        SedeId: 0,
        password: '',
        repeat_password: '',
        Direccion: {
            calle: '',
            altura: '',
            ciudad: '',
            provincia: 0,
            codigoPostal: '',
        },
        FiliacionId: 0,
        telefonoDomiciliario: '',
        telefonoCelular: '',
        personalEmail: '',
        legajoAlumno: '',
        legajoPersonaUTN: '',
        nacionalidad: 0,
        DocumentoDeIdentificacion: {
            numero : '',
            TipoDocumentoDeIdentificacionId : 0
        }
    });
    const [load,setLoad] = React.useState(false);

    const axiosInstance = setupInterceptorsTo(axios.create());
    const peticionGet = async () => {
        if (uid !== "") {
            setLoad(true)
            await axiosInstance({
                method: 'GET',
                url: `${RUTA_API_USUARIOS}/users/${uid} `,
            })
                .then(response => {
                    setLoad(false)
                    setUsuario(response.data)
                }).catch(error => {
                    setMessage("Hubo un error al intentar obtener la información del usuario (Codigo de error: 00041)");
                })
        }
        else return
    }

    React.useEffect( () => {
        if (open)
        peticionGet()
    },[uid,open])

    const handleClose = () => {
        resetearForm()
        setFechaNacimiento(null)
        onClose()
    }

    return (
        <ModalGeneral
            open={open}
            onClose={handleClose}
            load={load}
            Contenido={
            <FormularioAlta type={"Modificar"} closeModal={onClose} tab={2} prev={usuario} mostrarContrasena={false} mostrarLegajoAlumno={true}/>
            }
            />
    )
}